import { Field } from '@kanda-libs/ks-component-ts';
import useEnquiryWorkType from './useEnquiryWorkType';

const EnquiryWorkType: React.FunctionComponent = function ({}) {
  const { workTypeOptions, workTypeValidation } = useEnquiryWorkType();
  return (
    <Field.Validator validation={workTypeValidation}>
      <Field.Select
        name="job_info.work_type"
        options={workTypeOptions}
        placeholder="Select..."
        label="Type of Work"
      />
    </Field.Validator>
  );
};

export default EnquiryWorkType;
